const BASEURL = "https://watchstock-server.tententgc.com"; 

export default  BASEURL;